import Header from './Header';
import MobileNavigation from './MobileNavigation';
import frontImage from './img/software-integrations.png';
import epicLogo from './img/epicLogo.png';
import asclepius from './img/Asclepius.png';
import background from './img/softwarePartners.png';
import heart from './img/heart.svg';
import Footer from './Footer';
import { useRef, useState } from 'react';
import { useGSAP } from '@gsap/react';
import Select from 'antd/es/select';
import Input from 'antd/es/input';
import InputNumber from 'antd/es/input-number';
import Form from 'antd/es/form';
import Alert from 'antd/es/alert';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import backgroundSoftware from './img/softwarePartners.webp';
import axios from 'axios';

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);
export default function IntegrationsEpic() {
  const container = useRef();
  const [form] = Form.useForm();
  const [helpText, setHelpText] = useState(
    'I want to learn about integrating iQ Pro+ with my company’s software.'
  );
  const [alert, throwAlert] = useState(<></>);

  const handleChange = (value) => {
    if (value === 'New Merchant') {
      setHelpText('I’m new to Basys. I want to learn about accepting cards with iQ Pro+.');
    } else if (value === 'Current Merchant') {
      setHelpText('I’m a current Basys customer and I want to learn more about iQ Pro+.');
    } else if (value === 'Integrations Partner') {
      setHelpText('I want to learn about integrating iQ Pro+ with my company’s software.');
    } else {
      setHelpText(' ');
    }
  };

  const [validateStatusPhone, setValidateStatusPhone] = useState('');

  const onChangePhone = () => {
    const value = String(document.getElementById('pnumber').value);

    const result = /^\d{10}$/.test(value);
    if (result) {
      setValidateStatusPhone('success');
      document.getElementById('submitRequest').disabled = false;
    } else {
      setValidateStatusPhone('error');
    }
  };

  const onFinish = (values) => {
    document.getElementById('submitRequest').disabled = true;
    const value = String(document.getElementById('pnumber').value);
    const result = /^\d{10}$/.test(value);
    if (!result) {
      throw new Error('The phone number is not 10 digits');
    }
    console.log('Email sending...');
    setValidateStatusPhone('');
    let date = new Date();
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    const userDate = date.toISOString().split('T')[0];
    values.date = userDate;
    values.companyName += ' - Integrations Epic';
    console.log(values);
    axios
      .post(`${process.env.REACT_APP_EMAIL_FUNCTION_URL}/api/sendleademail`, values)
      .then((res) => {
        if (res.status === 200) {
          console.log('success');
          throwAlert(
            <Alert
              message="Thank you for reaching out."
              description="Your request will be sent to one of our representatives."
              type="success"
              showIcon
              closable
            />
          );
          form.resetFields();
        }
      })
      .catch(function (error) {
        console.error(error);
        document.getElementById('submitRequest').disabled = false;
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  useGSAP(
    () => {
      gsap.fromTo(
        '.hero-left',
        { opacity: 0, y: 100 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.inOut' }
      );
      gsap.fromTo(
        '.cols-span-2',
        { opacity: 0, y: 100 },
        { opacity: 1, y: 0, duration: 1, ease: 'power2.inOut' }
      );
      let cards = gsap.utils.toArray('.card');
      gsap.from(cards, {
        duration: 1,
        opacity: 0,
        y: 50,
        stagger: 0.1,
        ease: 'power3.inOut',
        scrollTrigger: {
          trigger: '.card',
          start: 'top bottom-=200',
          end: 'top bottom+=100'
        }
      });
      gsap.fromTo(
        '.streamlined',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: {
            trigger: '.streamlined',
            start: 'top bottom-=200',
            end: 'top bottom+=100'
          }
        }
      );
      gsap.fromTo(
        '.simplify',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.simplify', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      const how = document.querySelector('.how').children;
      gsap.fromTo(
        how,
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.how', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      gsap.fromTo(
        '.security',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.security', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      gsap.fromTo(
        '.future',
        { opacity: 0, y: 100 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.in',
          stagger: 0.1,
          scrollTrigger: { trigger: '.future', start: 'top bottom-=200', end: 'top bottom+=100' }
        }
      );
      gsap.fromTo(
              '.landing-form',
              { opacity: 0, y: 100 },
              {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power2.in',
                scrollTrigger: {
                  trigger: '.landing-form',
                  start: 'top bottom-=300',
                  end: 'top bottom+=300'
                }
              }
            );
    },
    { context: container }
  );
  return (
    <>
      <main ref={container}>
        <Header />
        <MobileNavigation />
        <section className="">
          <div className="row hero-row">
            <article className="!gap-6 hero-left grid">
              <h2 className="text-left eyebrow text-[#4452A3] dark:text-[#A5ABD9]">
                SOFTWARE INTEGRATIONS
              </h2>
              <img src={epicLogo} alt="Epic logo" />
              <a href="#requestDemo" className="button button-primary has-arrow has-arrow-white">
                Book a Demo
              </a>
            </article>
            <figure className="cols-span-2">
              <img src={frontImage} alt="doctor writing" />
            </figure>
          </div>
        </section>
        <section className="">
          <div className="row streamlined">
            <div className="grid justify-center grid-cols-1">
              <p className="large">Streamlined patient payments by integrating Basys with Epic.</p>
            </div>
            <div className="grid grid-cols-1">
              <p className="light">
                Enhance your payment experience with Basys and Epic. Elevate your payment processing
                by integrating Basys’s robust payment solutions with the world’s largest provider of
                Electronic Health Records (EHR), Epic. Our integration is designed to blend
                seamlessly with Epic's system, ensuring a smooth, user-friendly experience for both
                your staff and patients. Unlike other solutions, Basys works naturally within your
                Epic environment, creating a streamlined workflow that’s automatic and hassle-free.
              </p>
            </div>
          </div>
        </section>
        <section className="">
          <div className="gap-6 row simplify">
            <div className="flex items-center self-stretch justify-start gap-6">
              <img className="m-0" src={asclepius} alt="medical icon" />
              <p className="large">Simplify payment processing for your health system.</p>
            </div>
            <div className="flex max-[639px]:flex-col items-start justify-center gap-8">
              <p className="w-[46%] max-[639px]:w-full light max-[639px]:self-center">
                A unified solution for payments across your organization. Basys’s Epic integration
                supports both patient and non-patient payments, making it easy for healthcare
                providers to handle transactions across their entire system. Our omnichannel
                solution simplifies payment acceptance for a more efficient and consistent
                experience.
              </p>
              <div className="w-[1px] h-48 bg-[#D9D9D9] max-[639px]:hidden"></div>
              <div
                className="flex flex-col items-start self-stretch justify-center gap-2"
                style={{ flex: '1 0 0' }}
              >
                <p className="light">
                  <i>Seamlessly post payments directly into Epic</i>
                </p>
                <p className="light">
                  <i>Supports transactions using Credit, Debit, FSA, and HRA cards</i>
                </p>
                <p className="light">
                  <i>Bank-neutral processing for flexibility</i>
                </p>
                <p className="light">
                  <i>Enterprise-level reporting with customizable configurations</i>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="">
          <div
            className="row"
            style={{
              borderRadius: '25px',
              backgroundImage: `url(${background})`,
              backgroundSize: '200% 200%',
              backgroundPosition: 'bottom center',
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div className="p-4 mx-auto md:p-8 how">
              <h3 className="text-white large">Flexible payment options for your patients.</h3>
              <p className="text-white light">
                Allow payments anytime, anywhere.With Basys’s integration into Epic, patients can
                easily make payments at their convenience, whether from home, at the office, or on
                the go. Our payment system is fully embedded into the Epic platform, ensuring smooth
                and secure transactions across a variety of payment methods, enhancing the overall
                experience for your patients and improving workflow for your staff.
              </p>
              <p className="text-white light">Key advantages:</p>
              <ul className="mt-8 fancy-bullets white">
                <li>
                  <p className="text-white light">
                    Accept multiple payment methods: credit cards, debit cards, ACH, and more
                  </p>
                </li>
                <li>
                  <p className="text-white light">
                    Built-in security features protect patient payment data
                  </p>
                </li>
                <li>
                  <p className="text-white light">
                    Reduces your PCI footprint and associated costs
                  </p>
                </li>
                <li>
                  <p className="text-white light">
                    Supports payments across various areas of your health system, including patient
                    services, gift shops, parking, cafeteria, and donations
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="">
          <div className="flex flex-col gap-6 row security">
            <p className="large">Data security you can count count on.</p>
            <div className="flex max-[639px]:flex-col items-start justify-center gap-8">
              <p className="w-[46%] light max-[639px]:self-center max-[639px]:w-full">
                Ensure safe transactions with every payment. When it comes to payment data, Basys
                ensures top-tier security. From credit card payments to online transactions, we
                protect sensitive information throughout the process, minimizing risks and reducing
                your compliance burdens.
              </p>
              <div className="w-[1px] h-48 bg-[#D9D9D9] max-[639px]:hidden"></div>
              <div
                className="flex flex-col items-start self-stretch justify-center gap-2"
                style={{ flex: '1 0 0' }}
              >
                <p className="light">
                  <i>Secure handling of card-present data</i>
                </p>
                <p className="light">
                  <i>Safe online payment processing</i>
                </p>
                <p className="light">
                  <i>Reduced PCI scope for simplified compliance</i>
                </p>
                <p className="light">
                  <i>Secure card-on-file storage options</i>
                </p>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row future">
            <section className="flex max-[639px]:flex-col gap-10 my-8 callout p-14">
              <img className="m-0 max-[639px]:scale-75 self-center" src={heart} alt="heart" />
              <div
                className="flex flex-col items-start justify-center gap-6"
                style={{ flex: '1 0 0' }}
              >
                <h2 className="text-left">
                  Future proof your payment solution with Basys's Epic integration.
                </h2>
                <p className="text-left light">
                  Basys is committed to providing a scalable, efficient, and secure payment solution
                  designed to evolve with your healthcare system. With our Epic integration, you can
                  enhance the payment experience for patients, streamline workflows for staff, and
                  gain valuable insights into your organization’s payment operations. Ready to
                  improve your payment processing? Basys is here to help.
                </p>
              </div>
            </section>
          </div>
        </section>
        <section>
          <div className="items-center justify-center row row-sm">
            <p className="text-center font-[1rem] light">
              Epic is a registered trademark of Epic Systems Corporation.
            </p>
          </div>
        </section>
{/* FORM */}
        <div className="landing-form">
          <div className="row row-sm">
            <section
              id="requestDemo"
              className="grid grid-cols-1 p-8 md:p-16"
              style={{
                borderRadius: '25px',
                backgroundImage: `url(${backgroundSoftware})`,
                backgroundSize: '200% 200%',
                backgroundPosition: 'bottom center',
                backgroundRepeat: 'no-repeat'
              }}
            >
              <h2 className="text-center text-white large">Ready to get started?</h2>
              <Form
                initialValues={{ leadType: 'Integrations Partner' }}
                id="form"
                form={form}
                className="grid grid-cols-1 gap-1"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <div className="grid items-center grid-cols-1 gap-2">
                  <p className="text-white label">I am a(n)...</p>
                  <label htmlFor="role" className="text-white label">
                    Select an option
                  </label>
                  <Form.Item name="leadType" className="w-full mb-0">
                    <Select
                      size="large"
                      id="role"
                      name="leadType"
                      onChange={handleChange}
                      style={{
                        width: '100%',
                        alignSelf: 'flex-start'
                      }}
                      options={[
                        {
                          value: 'Integrations Partner',
                          label: 'Integrations Partner'
                        },
                        {
                          value: 'New Merchant',
                          label: 'New Merchant'
                        },
                        {
                          value: 'Current Merchant',
                          label: 'Current Merchant'
                        },
                      ]}
                    />
                  </Form.Item>
                  <p className="mt-2 mb-4 text-white small light">{helpText}</p>
                </div>
                <div className="grid grid-cols-1 lg:gap-8 lg:grid-cols-2">
                  <div>
                    <label htmlFor="fname" className="text-white label">
                      First Name
                    </label>
                    <Form.Item
                      name="firstName"
                      rules={[
                        {
                          required: true,
                          message: 'Please add first name'
                        }
                      ]}
                    >
                      <Input id="fname" name="firstName" size="large" />
                    </Form.Item>
                  </div>
                  <div>
                    <label htmlFor="lname" className="text-white label">
                      Last Name
                    </label>
                    <Form.Item
                      name="lastName"
                      rules={[
                        {
                          required: true,
                          message: 'Please add last name'
                        }
                      ]}
                    >
                      <Input id="lname" name="lastName" size="large" />
                    </Form.Item>
                  </div>
                </div>
                <div className="grid grid-cols-1">
                  <label htmlFor="cname" className="text-white label">
                    Company Name
                  </label>
                  <Form.Item
                    name="companyName"
                    className="w-full"
                    rules={[
                      {
                        required: true,
                        message: 'Please add company name'
                      }
                    ]}
                  >
                    <Input id="cname" name="companyName" size="large" />
                  </Form.Item>
                </div>
                <div className="grid items-center grid-cols-1 lg:gap-8 lg:grid-cols-2">
                  <div>
                    <label htmlFor="email" className="text-white label">
                      Email
                    </label>
                    <Form.Item
                      name="email"
                      validateTrigger="onBlur"
                      rules={[
                        {
                          type: 'email',
                          required: true,
                          message: 'Please use a valid email'
                        }
                      ]}
                    >
                      <Input id="email" name="email" size="large" />
                    </Form.Item>
                  </div>
                  <div>
                    <label htmlFor="pnumber" className="text-white label">
                      Phone Number
                    </label>
                    <Form.Item
                      name="phoneNumber"
                      validateStatus={validateStatusPhone}
                      hasFeedback
                      rules={[
                        {
                          required: true,
                          message: 'Please add a 10 digit phone number, do not enter spaces or dashes'
                        }
                      ]}
                    >
                      <InputNumber
                        id="pnumber"
                        name="phoneNumber"
                        placeholder="##########"
                        size="large"
                        className="w-full"
                        onBlur={onChangePhone}
                        maxLength={10}
                      />
                    </Form.Item>
                  </div>
                </div>
                <div className="grid items-center justify-center grid-cols-1">
                  <Form.Item className="mb-0">
                    <button
                      type="submit"
                      id="submitRequest"
                      className="button button-primary-dark has-arrow has-arrow-left"
                    >
                      Submit
                    </button>
                  </Form.Item>
                </div>
              </Form>
              {alert}
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
